import { configureStore } from '@reduxjs/toolkit'
import userReducer from './slices/userSlice'
import outlineReducer from './slices/outlineSlice'
import documentShareReducer from './slices/documentShareSlice'
import modalReducer from './slices/openModalSlice'
import presentationOptionsReducer from './slices/presentationOptionsSlice'
import templateReducer from './slices/templateSlice'
import discountReducer from './slices/discountSlice'
import razorpayPlansReducer from './slices/razorpayPlansSlice'

export const store = configureStore({
  reducer: {
    user: userReducer,
    outline: outlineReducer,
    documentShare: documentShareReducer,
    openModal: modalReducer,
    presentationOptions: presentationOptionsReducer,
    template: templateReducer,
    discount: discountReducer,
    razorpayPlans: razorpayPlansReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
